var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-breadcrumbs',{attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{attrs:{"to":item.to,"disabled":item.disabled,"exact":item.exact}},[_c('icon',{attrs:{"left":"","outlined":"","size":"24","name":item.icon}}),_c('span',{staticClass:"v-breadcrumbs__text"},[_vm._v(" "+_vm._s(item.text)+" ")])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }